module.exports = __webpack_public_path__ + "static/media/critical-alert.b1a15d93.mp3";